import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { ButtonBase, Stack, Typography } from '@mui/material';
import {
  AdsClick as AdsClickIcon,
  ChevronRight as ChevronRightIcon,
  PublicOutlined as PublicIcon,
} from '@mui/icons-material';
import { useTranslation } from 'react-i18next';

// The card itself opens the conversation: keep the campaign link's click (and
// its ripple) from reaching it.
const stopPropagation = (event) => event.stopPropagation();

// De onde o lead veio — campanha ou outra origem cadastrada. Um lead tem só
// uma origem por vez; campanha tem prioridade quando as duas vierem preenchidas.
// A campanha abre o detalhe dela (/campaigns/:id).
const LeadOriginInfo = ({ campaignId, campaignTitle, campaignExternalId, originName }) => {
  const { t } = useTranslation();

  if (campaignId) {
    const label = `${t('leads.campaign')}: ${campaignTitle || campaignExternalId}`;

    return (
      <ButtonBase
        component={RouterLink}
        to={`/campaigns/${campaignId}`}
        onClick={stopPropagation}
        onMouseDown={stopPropagation}
        onTouchStart={stopPropagation}
        sx={{
          width: '100%',
          justifyContent: 'flex-start',
          border: 1,
          borderColor: 'divider',
          borderRadius: 2,
          p: 1,
          px: 1.5,
          '&:hover': { bgcolor: 'action.hover' },
        }}
      >
        <Stack direction="row" alignItems="center" spacing={1} sx={{ width: '100%', minWidth: 0 }}>
          <AdsClickIcon fontSize="small" color="primary" sx={{ flexShrink: 0 }} />
          <Typography
            variant="body2"
            color="primary"
            noWrap
            sx={{ flex: 1, minWidth: 0, textAlign: 'left' }}
          >
            {label}
          </Typography>
          <ChevronRightIcon fontSize="small" color="action" sx={{ flexShrink: 0 }} />
        </Stack>
      </ButtonBase>
    );
  }

  if (!originName) return null;

  return (
    <Stack direction="row" alignItems="center" spacing={1}>
      <PublicIcon fontSize="small" color="action" sx={{ flexShrink: 0 }} />
      <Typography variant="body2" color="text.secondary" noWrap sx={{ flex: 1, minWidth: 0 }}>
        {originName}
      </Typography>
    </Stack>
  );
};

export default LeadOriginInfo;
